<div class="modal-header">
  <h4 class="modal-title pull-left">Select/Enter the Appropriation Chargeable Code</h4>
  <button type="button"  class="close pull-right" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="container-fluid">
    this is select modal
  </div>
</div>
<div class="modal-footer">
  <button type="button"  class="btn btn-primary" (click)="closeModal()">Close</button>
  <button type="button"  class="btn btn-primary">Save</button>
</div>
